var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = [1, 2, 5].includes(_vm.orderType)
  var g1 = [1, 3].includes(_vm.orderType)

  var m0 = require("@/static/public/right.png")

  var g2 = [0, 1, 5].includes(_vm.detail.orderClosedStatus)
  var g3 = [5, 1, 0].includes(_vm.detail.orderClosedStatus)
  var g4 = [10].includes(_vm.detail.orderStatus)
  var g5 = [100].includes(_vm.detail.orderStatus)
  var g6 = [5, 1, 0].includes(_vm.detail.orderClosedStatus)
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        m0: m0,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
        g6: g6
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }